<m-chip-add
    v-if="isModeAdd"
    :disabled="disabled"
    :size="size"
    :tabindex="tabindex"
    @click="emitClick"
    @add="emitAdd"
>
    <slot />
</m-chip-add>
<m-chip-delete
    v-else-if="isModeDelete"
    :disabled="disabled"
    :size="size"
    :tabindex="tabindex"
    @click="emitClick"
    @delete="emitDelete"
>
    <slot />
</m-chip-delete>

